import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Download from './pages/Download';
import Pricing from './pages/Pricing';
import MarketplaceApp from './pages/MarketplaceApp';
import AuthCallback from './pages/AuthCallback';
import AccountDashboard from './pages/AccountDashboard';
import ProductDetail from './pages/ProductDetail';
import ScrollToTopOnRouteChange from './components/ScrollToTopOnRouteChange';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import './App.css';

function App() {
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <ThemeProvider>
    <AuthProvider>
    <CartProvider>
    <BrowserRouter>
      <ScrollToTopOnRouteChange />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/download" element={<Download />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/marketplace" element={<MarketplaceApp />} />
        <Route path="/marketplace/:category/:product" element={<ProductDetail />} />
        <Route path="/account" element={<AccountDashboard />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
      </Routes>
    </BrowserRouter>
    </CartProvider>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
